import Home from 'components/molecules/Home';
import React, { useEffect } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { paymentModesSlice, triggerGetPaymentModesApi } from 'Slices';
import { registerSlice } from 'store';
import { globalId } from '../../index';
import { useHistory } from 'react-router';
import { loadState } from 'utils/LocalStorage';
import './styles.scss';
registerSlice(paymentModesSlice);

const Container: React.FC = () => {
	const history = useHistory();
	const wroute = loadState('wroute', true);

	const dispatch = useDispatch();

	useEffect(() => {
		console.log(
			'-------------------------------type of device and client---------------------------',
			loadState('deviceType', true),
			loadState('applicationName', true),
			loadState('clientName', true),
		);
	}, []);

	useEffect(() => {
		if (wroute === 'thanks') {
			history.push('/thanks');
			return;
		}
		dispatch(triggerGetPaymentModesApi(globalId as any));
	}, [dispatch]);
	return <Home />;
};
export default Container;
